import { FC } from 'react';
import { BaseCell } from './BaseCell';

type TextCellProps = Record<string, any>;

const createTextCell =
  (useBaseCell: boolean): FC<React.PropsWithChildren<TextCellProps>> =>
  ({ children, value, ...props }) => {
    const Cell = <span {...props}>{children || value}</span>;
    if (useBaseCell) {
      return <BaseCell>{Cell}</BaseCell>;
    }

    return Cell;
  };

export const TextCell = createTextCell(true);
export const CleanTextCell = createTextCell(false);
